import {
    Accordion,
    AccordionDetails,
    AccordionSummary, Alert,
    Box, Button,
    Link,
    List,
    ListItem,
    Paper,
    Stack,
    Typography
} from "@mui/material";
import {useMainContext} from "../constants";
import {ExpandMore, OpenInNew} from "@mui/icons-material";

export default function Jerseys() {

    const { mainVariant, smallVariant, smallerVariant, smallestVariant } = useMainContext();

    return (
        <Box sx={{ maxWidth: 'lg',
            paddingLeft: { xs: "10px", sm: "20px", md: "30px"},
            paddingRight: { xs: "10px", sm: "20px", md: "30px"},
            paddingBottom: { xs: "10px", sm: "20px", md: "30px"},
            marginLeft: "auto", marginRight: "auto" }}>
            <Stack direction="column" spacing={2} sx={{ marginTop: { xs: "10px", sm: "15px", md: "20px"}}}>
                <Typography variant={ smallerVariant } sx={{ fontWeight: "bold"}}>Jersey Information</Typography>
                <Typography variant="body1">
                    We refresh our uniform contract with Soccer.com every two years, but we always select styles that closely match our previous kit.
                </Typography>

                <Typography variant={ smallestVariant } sx={{ fontWeight: "bold", marginTop: "10px" }}>
                    Do I need to Order?
                </Typography>
                <List>
                    <ListItem>
                        <Typography variant="body1">
                            <strong>Returning Players:</strong> If your player's current uniform still fits and they have the correct jersey number, you do not need to order a new one. You are welcome to reuse last year's kit.
                        </Typography>
                    </ListItem>
                    <ListItem>
                        <Typography variant="body1">
                            <strong>Note on Design:</strong> Every two years, the new Black and Grey jerseys can feature updated background design patterns, but we always make sure they blend in with our older style.
                        </Typography>
                    </ListItem>
                    <ListItem>
                        <Typography variant="body1">
                            <strong>New Players or Size Upgrades:</strong> If you are new to the program or your player has outgrown their old gear, you will need to place an order. These uniforms are yours to keep!
                        </Typography>
                    </ListItem>
                </List>

                <Typography variant={ smallestVariant } sx={{ fontWeight: "bold", marginTop: "10px" }}>
                    What to Order by Division
                </Typography>

                <List>
                    <ListItem>
                        <Typography variant="body1">
                            <strong>Co-ed Modified Division:</strong> You only need to order the Black uniform kit.
                        </Typography>
                    </ListItem>
                    <ListItem>
                        <Typography variant="body1">
                            <strong>Varsity Teams:</strong> You are required to have both the Black and Grey uniform kits.
                        </Typography>
                    </ListItem>
                </List>

                <Typography variant={ smallestVariant } sx={{ fontWeight: "bold", marginTop: "10px" }}>
                    Important Ordering Guidelines
                </Typography>

                <List>
                    <ListItem>
                        <Typography variant="body1">
                            <strong>Shorts & Socks Policy:</strong> You are not required to order the official black shorts or black socks through Soccer.com. As long as you provide your own plain black shorts and black socks for games, you can remove those specific items from your Soccer.com cart to save on costs.
                        </Typography>
                    </ListItem>
                    <ListItem>
                        <Typography variant="body1">
                            <strong>Check the Name & Number:</strong> Jerseys default to printing your last name on the back. You can change this name during checkout if you prefer. Because these are fully customized items, all sales are final. Please double-check the spelling and jersey number before submitting.
                        </Typography>
                    </ListItem>
                    <ListItem>
                        <Typography variant="body1">
                            <strong>Combine Orders to Save Shipping:</strong> If you are ordering for multiple players, make sure to add all items to a single cart before checking out to save on shipping costs.
                        </Typography>
                    </ListItem>
                    <ListItem>
                        <Typography variant="body1">
                            <strong>Shipping Timeline:</strong> Custom uniforms typically take 4 to 6 weeks to arrive. Please do not delay in placing your order if you need new gear, as we want everyone equipped by the start of the season.
                        </Typography>
                    </ListItem>
                </List>
                <Alert
                    severity="info"
                    action={
                        <Button
                            color="inherit"
                            size="small"
                            href="/soccerUniformOrdering.pdf" // Replace with your link/PDF
                            target="_blank"
                            rel="noopener noreferrer"
                            endIcon={<OpenInNew />}
                        >
                            View Guide
                        </Button>
                    }
                    sx={{ marginTop: '10px' }}
                >
                    <strong>Need help placing your order?</strong> Read our step-by-step ordering instructions.
                </Alert>
            </Stack>
        </Box>
    )
}
